// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  runId: __t.u64().primaryKey().name("run_id"),
  runKey: __t.string().name("run_key"),
  identity: __t.identity(),
  label: __t.string(),
  backend: __t.string(),
  userAgent: __t.string().name("user_agent"),
  tiers: __t.string(),
  legSeconds: __t.u32().name("leg_seconds"),
  status: __t.string(),
  notes: __t.string(),
  startedAt: __t.timestamp().name("started_at"),
  endedAt: __t.timestamp().name("ended_at"),
});
